// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DrawerHeader-base__oLy1G{position:sticky;top:var(--size-0);z-index:var(--z-index-drawer);display:flex;flex-direction:column;width:var(--size-full)}.DrawerHeader-base__oLy1G .DrawerHeader-dragHandleWithBody__U6Srl{align-items:flex-end;height:var(--size-3_5)}.DrawerHeader-popoverHeader__WS4oU{width:var(--size-full)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "DrawerHeader-base__oLy1G",
	"dragHandleWithBody": "DrawerHeader-dragHandleWithBody__U6Srl",
	"popoverHeader": "DrawerHeader-popoverHeader__WS4oU"
};
export default ___CSS_LOADER_EXPORT___;
